<template>
    <div class="">
        <div v-if="isVersioning" class="version-ing">
            <p class="fwbd mt20">重庆众安小额贷款有限公司是一家经中国政府批准的，具备合法合规金融资质的公司，我们始终遵循国家法律政策，为广大用户提供放心，便捷的服务。</p>
            <p class="fwbd mt20">“点点”是重庆众安小额贷款有限公司旗下独立研发、运营的的一款金融产品，版权为重庆众安小额贷款有限公司所有。</p>
            <p class="fwbd mt20">Copyright ©2017众安小贷®版权所有</p>
            <p class="fwbd mt20">All rights reserved</p>
        </div>
        <div v-if="!isVersioning" class="about-detail">
            <div class="">
                <div class="ad-header"></div>
                <div class="ad-box mt-f ab-1">
                    <div class="ad-title">关于点点</div>
                    <p class="ad-mt"><b>·点点</b>，国内领先的智能生活金融服务平台，旨为中国消费者提供最优质的综合生活与金融连接服务，已与国内众多知名金融机构达成深度合作。</p>
                    <!-- <p><b>·众安保险</b>，为点点的深度战略合作伙伴。众安（股票代码:HK06060）是由蚂蚁金服、腾讯与中国平安发起设立，并为点点用户提供全面账户信息安全保障服务。</p> -->
                </div>
                <div class="ad-box ab-2 mt-25">
                    <div class="ad-title">了解点点</div>
                    <ul class="ad-info">
                        <li>
                            <div class="ad-icon"><div class="ad-pic"></div></div>
                            <div class="ad-test">
                                <h2>方便一点</h2>
                                <p>额度最高至20万，日费率低至0.025%起，极速审核，为应急解忧</p>
                            </div>
                        </li>
                        <li>
                            <div class="ad-icon"><div class="ad-pic"></div></div>
                            <div class="ad-test">
                                <h2>安全一点</h2>
                                <p>已与国内众多知名机构深度合作</p>
                            </div>
                        </li>
                        <li>
                            <div class="ad-icon"><div class="ad-pic"></div></div>
                            <div class="ad-test">
                                <h2>品质一点</h2>
                                <p>精选稀缺商品、分期免息买好物,助力品质生活</p>
                            </div>
                        </li>
                        <li>
                            <div class="ad-icon"><div class="ad-pic"></div></div>
                            <div class="ad-test">
                                <h2>实惠一点</h2>
                                <p>各类优惠券、免息券拿到手软,积分兑换、促销活动天天办</p>
                            </div>
                        </li>
                        <li>
                            <div class="ad-icon"><div class="ad-pic"></div></div>
                            <div class="ad-test">
                                <h2>丰富一点</h2>
                                <p>可还信用卡、可线下消费,想你所想一站式服务</p>
                            </div>
                        </li>
                        <li>
                            <div class="ad-icon"><div class="ad-pic"></div></div>
                            <div class="ad-test">
                                <h2>便利一点</h2>
                                <p>充值缴费、看电影……足不出户便利生活</p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="ad-footer mt-20"></div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
@import '../assets/styles/all.scss';
.version-ing{
    padding: r(20)
}
.about-detail{
    max-width: 640px;
    background:#f2f2f2;
    .ad-header{
        height: r(211);
        background: url('../assets/images/gy-header-bg.jpg');
        background-size: 100% 100%;
    }
    .ad-box{
        position: relative;
        background: #ffffff;
        border-radius: r(5);
        width: r(342);
        margin: 0 auto;
        box-shadow: 0 0 2px 1px #ebeff2;
        padding: 0 r(20);
        box-sizing: border-box;
        p{
            font-size: r(13);
        }
        .ad-mt{
            padding-top: r(40);
        }
        .ad-title{
            color: #fefdf8;
            font-size: r(15);
            text-align: center;
            line-height: r(30);
            width: r(147);
            height: r(32);
            background: url('../assets/images/lianmu-bg.png');
            background-size: 100% 100%;
            position: absolute;
            left: 50%;
            top: r(-7);
            -webkit-transform:translateX(-50%);
        }
    }
    .mt-f{
        margin-top: r(-30);
    }
    .ab-1{
        height: r(120);
        p{
            margin-bottom: r(10);
        }
    }
    .ab-2{
        ul{
            padding: r(40) r(0) r(20) r(0);
            li{
                margin-bottom: r(25);
                position: relative;
                .ad-icon{
                    width: r(41);
                    height: 100%;
                    position: absolute;
                    left: 0;
                    top: 0;
                    .ad-pic{
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        -webkit-transform:translate(-50%,-50%);
                    }
                }
                .ad-test{
                    padding-left: r(60);
                    h2{
                        font-size: r(17);
                        color: #333333;
                        font-weight: 500;
                        padding-bottom: r(5);
                    }
                    p{
                        font-size: r(13);
                        color: #666666;
                    }
                }
            }
            li:nth-child(1){
                .ad-icon{
                    .ad-pic{
                        width: r(41);
                        height: r(35);
                        background: url('../assets/images/gy-icon-1.png');
                        background-size: 100% 100%;
                    }
                }
            }
            li:nth-child(2){
                .ad-icon{
                    .ad-pic{
                        width: r(28);
                        height: r(33);
                        background: url('../assets/images/gy-icon-2.png');
                        background-size: 100% 100%;
                    }
                }
            }
            li:nth-child(3){
                .ad-icon{
                    .ad-pic{
                        width: r(34);
                        height: r(30);
                        background: url('../assets/images/gy-icon-3.png');
                        background-size: 100% 100%;
                    }
                }
            }
            li:nth-child(4){
                .ad-icon{
                    .ad-pic{
                        width: r(35);
                        height: r(26);
                        background: url('../assets/images/gy-icon-4.png');
                        background-size: 100% 100%;
                    }
                }
            }
            li:nth-child(5){
                .ad-icon{
                    .ad-pic{
                        width: r(34);
                        height: r(28);
                        background: url('../assets/images/gy-icon-5.png');
                        background-size: 100% 100%;
                    }
                }
            }
            li:nth-child(6){
                .ad-icon{
                    .ad-pic{
                        width: r(35);
                        height: r(36);
                        background: url('../assets/images/gy-icon-6.png');
                        background-size: 100% 100%;
                    }
                }
            }
        }
    }


    .mt-25{
        margin-top: r(25)
    }

    .mt-20{
        margin-top: r(20)
    }

    .ad-footer{
        height: r(238);
        background: url('../assets/images/gy-footer-bg.jpg');
        background-size: 100% 100%;
    }
}
</style>

<script>
    export default {
        data(){
            return {
                isVersioning:false
            }
        },
        created(){
        },
        mounted(){
            if(localStorage.getItem('appApplySwitch')=='1'){
                this.isVersioning=true
            }else{
                this.isVersioning=false
            }
        },
        beforeRouteEnter (to, from, next) {
            document.title = '关于点点'
            next()
        },
    }
</script>



// WEBPACK FOOTER //
// aboutdetail.vue?2c2f30b8